"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../../theming");

var _themeContants = require("../../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Digit = function Digit(_ref) {
  var isAnimating = _ref.isAnimating,
      digit = _ref.digit,
      speed = _ref.speed,
      size = _ref.size,
      single = _ref.single,
      variant = _ref.variant;
  return _react["default"].createElement(DigitWrapper, {
    isAnimating: true,
    size: size,
    isEmpty: !digit,
    variant: variant
  }, _react["default"].createElement(DigitContainer, {
    digit: digit,
    speed: speed,
    single: single,
    size: size,
    variant: variant
  }, !digit ? "" : single ? digit : "0 1 2 3 4 5 6 7 8 9 0"));
};

Digit.themeProps = {
  wrapper: {
    name: "digit",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  container: {
    name: "digit_container",
    description: "Container style",
    type: _themeContants.themePropTypes.style
  }
};

var DigitWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Digit__DigitWrapper",
  componentId: "sc-1ujerel-0"
})(["height:", "px;width:", "px;overflow:hidden;", ";"], function (p) {
  return p.size;
}, function (p) {
  return p.isEmpty ? p.size / 2 : p.size / 1.5;
}, (0, _theming.applyVariants)(Digit.themeProps.wrapper.name));

var DigitContainer = _styledComponents["default"].div.withConfig({
  displayName: "Digit__DigitContainer",
  componentId: "sc-1ujerel-1"
})(["font-size:", "px;", ";", ";"], function (p) {
  return p.size;
}, function (p) {
  return !p.single && "\n      animationname: slide".concat(p.digit, ";\n      transform: translateY(-").concat(p.digit, "em);\n      transition: transform ").concat(p.speed, "ms cubic-bezier(0, 0, 0.2, 1);\n      ");
}, (0, _theming.applyVariants)(Digit.themeProps.container.name));

Digit.propTypes = {
  digit: _propTypes["default"].string.isRequired,
  speed: _propTypes["default"].number.isRequired,
  size: _propTypes["default"].number.isRequired,
  isAnimating: _propTypes["default"].bool,
  single: _propTypes["default"].bool
};
var _default = Digit;
exports["default"] = _default;